// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TrafficconfigAzureProperties
 */
export interface TrafficconfigAzureProperties {
  /**
   *
   * @type {Array<string>}
   * @memberof TrafficconfigAzureProperties
   */
  endpointIds?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof TrafficconfigAzureProperties
   */
  subscriptionIds?: Array<string>;
}

/**
 * Check if a given object implements the TrafficconfigAzureProperties interface.
 */
export function instanceOfTrafficconfigAzureProperties(
  value: object,
): value is TrafficconfigAzureProperties {
  return true;
}

export function TrafficconfigAzurePropertiesFromJSON(
  json: any,
): TrafficconfigAzureProperties {
  return TrafficconfigAzurePropertiesFromJSONTyped(json, false);
}

export function TrafficconfigAzurePropertiesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TrafficconfigAzureProperties {
  if (json == null) {
    return json;
  }
  return {
    endpointIds:
      json['endpoint_ids'] == null ? undefined : json['endpoint_ids'],
    subscriptionIds:
      json['subscription_ids'] == null ? undefined : json['subscription_ids'],
  };
}

export function TrafficconfigAzurePropertiesToJSON(
  json: any,
): TrafficconfigAzureProperties {
  return TrafficconfigAzurePropertiesToJSONTyped(json, false);
}

export function TrafficconfigAzurePropertiesToJSONTyped(
  value?: TrafficconfigAzureProperties | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    endpoint_ids: value['endpointIds'],
    subscription_ids: value['subscriptionIds'],
  };
}
